export const getFinancialYearStartYear = (date = new Date()) => {
  const month = date.getMonth();
  const year = date.getFullYear();

  return month >= 3 ? year : year - 1;
};

export const getFinancialYearLabel = (startYear) =>
  `AY ${startYear + 1}-${String(startYear + 2).slice(-2)}`;

export const getFinancialYearOptions = (startYear = 2023, endYear = 2030) => {
  return Array.from({ length: endYear - startYear + 1 }, (_, index) => {
    const year = startYear + index;

    return {
      value: String(year),
      label: getFinancialYearLabel(year),
    };
  });
};

export const getCurrentFinancialYearValue = () =>
  String(getFinancialYearStartYear());

export const getFinancialYearRange = (financialYearValue) => {
  const startYear = Number(financialYearValue);

  if (Number.isNaN(startYear)) {
    return null;
  }

  return {
    start: new Date(startYear, 3, 1, 0, 0, 0, 0),
    end: new Date(startYear + 1, 2, 31, 23, 59, 59, 999),
  };
};

export const toDateSafe = (value) => {
  if (!value) return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  if (typeof value?.toDate === "function") {
    const date = value.toDate();
    return Number.isNaN(date.getTime()) ? null : date;
  }

  const seconds = value?.seconds ?? value?._seconds;
  if (typeof seconds === "number") {
    const nanos = value.nanoseconds ?? value._nanoseconds ?? 0;
    return new Date(seconds * 1000 + nanos / 1000000);
  }

  if (typeof value === "number" || typeof value === "string") {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  return null;
};

export const isDateInFinancialYear = (value, financialYearValue) => {
  const range = getFinancialYearRange(financialYearValue);
  const date = toDateSafe(value);

  if (!range || !date) {
    return false;
  }

  return date >= range.start && date <= range.end;
};

export const getRecordDate = (record) =>
  toDateSafe(
    record?.createdAt ||
      record?.timestamp ||
      record?.tdsFormData?.timestamp ||
      record?.tdsState?.timestamp ||
      null,
  );
